import { render, staticRenderFns } from "./m-block-multiple-tax-bills-sending.vue?vue&type=template&id=6d8ac39e&scoped=true&lang=pug&"
import script from "./m-block-multiple-tax-bills-sending.vue?vue&type=script&lang=js&"
export * from "./m-block-multiple-tax-bills-sending.vue?vue&type=script&lang=js&"
import style0 from "./m-block-multiple-tax-bills-sending.vue?vue&type=style&index=0&id=6d8ac39e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ac39e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VDataTable,VProgressLinear})
